module.exports = __webpack_public_path__ + "assets/img/elektrines-ant-fasado.fc2fb0b7.jpg";